import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./root-state.reducer"; 
import { rAPI } from "../services";
import { uploadMiddleware } from "../images/upload-middleware";
import { injectStore } from "../api/fetch";

declare const process: any;

const isDevelopment = process.env.NODE_ENV === 'development';

const rootStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore specific action types if needed (e.g., for file uploads)
            ignoredActions: ['uploads/initiateUpload'],
            // Ignore specific field paths in actions, including RTK Query metadata and file payloads
            ignoredActionPaths: [
              'payload.file', 
              'meta.baseQueryMeta.request', 
              'meta.baseQueryMeta.response'
            ],
            // Ignore specific paths in the Redux state, targeting RTK Query metadata
            ignoredPaths: [
              /assetApi\.queries\..*\.meta\.baseQueryMeta\.(request|response)/,
              /assetApi\.mutations\..*\.meta\.baseQueryMeta\.(request|response)/,
            ]
          }        
    }).concat(rAPI.middleware, uploadMiddleware),
    devTools: isDevelopment,
    //preloadedState: initialRootState,
});

injectStore(rootStore);

export type AppDispatch = typeof rootStore.dispatch;

export { rootStore };

export type RootState = ReturnType<typeof rootStore.getState>;

export default rootStore;